import { useQuery } from '@hooks/reactQuery';

import { getConfigurationTemplateConfigTypesOptions } from '@api/configurationTemplates';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONFIGURATION_TEMPLATES_CONFIG_TYPES_OPTIONS } from '@constants/queryKeys';

interface IUseQueryConfigurationTemplatesConfigTypesOptions {
	configTypesOptions: TSelectOption<string>[];
	isLoadingConfigTypesOptions: boolean;
}

const useQueryConfigurationTemplatesConfigTypesOptions = (): IUseQueryConfigurationTemplatesConfigTypesOptions => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [CONFIGURATION_TEMPLATES_CONFIG_TYPES_OPTIONS],
		queryFn: getConfigurationTemplateConfigTypesOptions,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		configTypesOptions: data || [],
		isLoadingConfigTypesOptions: isInitialLoading,
	};
};

export default useQueryConfigurationTemplatesConfigTypesOptions;
